export default __webpack_public_path__ + "static/media/map.594ff478.png";